import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import { BrandSponsoredLabel } from '../brand-sponsored-label';

export interface BrandSponsoredLabelCompatProps {
  className?: string;
  expanded?: boolean;
}

@inject(deps)
@observer
export class BrandSponsoredLabelCompat extends Component<BrandSponsoredLabelCompatProps> {
  render() {
    const licenceTooltipContent = `If you select a Brand Sponsored license, you can legally use this song in a video you’re being paid for to promote a brand.`;

    const i18n = {
      ...BrandSponsoredLabel.i18n,
      title: licenceTooltipContent,
    };

    return <BrandSponsoredLabel i18n={i18n} {...this.props} />;
  }
}
